/**
 * meta.pPath 用于顶部菜单 选中(尤其在详情页面，其父类菜单要求时选中的)
 * meta.head 默认显示导航1，2显示导航2, -1不显示导航
 * meta.whiteBackground: 默认为灰色背景 true 为白色背景
 * meta.roles 角色 展商（ACTOR）,客商（VISITOR）,游客（''）
 */
const routesVistor = [
    {
        // 新邮箱注册 2020.8.10
        path: '/register/:type(email)/:id(0|1|2)',
        name: 'registerEmail',
        component: () => import( /* webpackChunkName: "register_Email" */ '../views/login/register_Email.vue'),
        meta: {
            head: -1,
            title: 'register',
            roles: ['VISITOR']
        }
    },
    {
        // 新手机号注册 2020.8.10
        path: '/register/:type(mobile)/:id(0|1|2)',
        name: 'registerMobile',
        component: () => import( /* webpackChunkName: "register_Mobile" */ '../views/login/register_Mobile.vue'),
        meta: {
            head: -1,
            title: 'register',
            roles: ['VISITOR']
        }
    },
    {
        // 新设置密码 2020.8.10
        path: '/register/password/:type(vis)',
        name: 'registerPassWord',
        component: () => import( /* webpackChunkName: "registerPassWord" */ '../views/login/registerPassWord.vue'),
        meta: {
            head: -1,
            title: 'register',
            roles: ['VISITOR']
        }
    },
    {
        // 预登记完成
        path: '/register/completed',
        name: 'registerCompleted',
        component: () => import( /* webpackChunkName: "register_completed" */ '../views/login/register_completed.vue'),
        meta: {
            head: -1,
            title: 'register',
            roles: ['VISITOR']
        }
    },
    {
        // 邮箱完善信息
        // 0 第一次完善信息
        path: '/l-register/account-email-info/:type(0)',
        name: 'lAccountInfoEmail',
        component: () => import( /* webpackChunkName: "lAccountInfo" */ '../views/register/accountInfo.vue'),
        meta: {
            head: -1,
            title: 'register',
            roles: ['VISITOR']
        }
    },
    {
        // 手机号完善信息
        // 0 第一次完善信息
        path: '/l-register/account-mobile-info/:type(0)',
        name: 'lAccountInfoMobile',
        component: () => import( /* webpackChunkName: "lAccountInfo" */ '../views/register/accountInfo.vue'),
        meta: {
            head: -1,
            title: 'register',
            roles: ['VISITOR']
        }
    },
    {
        // 注册
        path: '/register',
        name: 'register',
        meta: {
            head: -1
        },
        component: () => import( /* webpackChunkName: "register" */ '../views/register/index.vue'),
        children: [{
            // 1 第二次完善信息
            path: 'account-info/:type(1)',
            name: 'account-info',
            meta: {
                head: -1,
                roles: ['VISITOR']
            },
            component: () => import( /* webpackChunkName: "account-info" */ '../views/register/accountInfo.vue')
        }, {
            // 问卷
            path: '/questionnaire',
            name: 'questionnaire',
            meta: {
                head: -1,
                roles: ['VISITOR']
            },
            component: () => import( /* webpackChunkName: "questionnaire" */ '../views/register/questionnaire.vue')
        }]
    },
    {
        // 客商 基本信息
        path: '/profile',
        name: 'Profile',
        meta: {
            title: 'profile',
            roles: ['VISITOR']
        },
        component: () => import('../views/personalCenter/profile.vue')
    },
    {
        // 客商 公司信息
        path: '/companyfile',
        name: 'Companyfile',
        meta: {
            title: 'profile',
            roles: ['VISITOR']
        },
        component: () => import('../views/personalCenter/profile.vue')
    }
]

export default routesVistor
